<template>
  <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.9755 3.125V26.875C14.9255 26.875 14.863 26.875 14.813 26.85C14.7255 26.825 5.22545 23.85 5.22545 15.8375C5.22545 13.55 5.18795 11.8875 5.16295 10.675C5.11295 7.675 5.10045 7.125 5.80045 6.425C6.68795 5.55 13.6505 3.15 14.9755 3.125Z"
      fill="white" />
    <path
      opacity="0.4"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.8371 10.6875C24.8121 11.9 24.7746 13.55 24.7746 15.8375C24.7746 23.85 15.2746 26.825 15.1871 26.85C15.1246 26.875 15.0621 26.875 14.9996 26.875H14.9746V3.125H14.9996C16.2746 3.125 23.3121 5.55 24.1996 6.425C24.8996 7.125 24.8871 7.675 24.8371 10.6875Z"
      fill="white" />
  </svg>
</template>
